'use client';

import { useDynamicConfig } from '@statsig/react-bindings';
import { useReducedMotion } from 'framer-motion';

import Motion from '@/app/components/Motion';

import MABGrid from './_components/MABGrid';
import MABHero from './_components/MABHero';
import type { Profile } from './_components/MABRow';

const Content = () => {
  const shouldReduceMotion = useReducedMotion();
  const { value } = useDynamicConfig('medical_advisory_board_profiles');
  const profiles = value['profiles'] as Profile[];

  return (
    <div
      className="relative bg-sandstone-200"
      data-cy="medical-advisory-board-page"
    >
      <Motion
        animate={{
          opacity: 1,
          filter: 'blur(0px)',
          y: 0,
          transition: {
            type: 'tween',
            duration: shouldReduceMotion ? 0 : 0.8,
            staggerChildren: shouldReduceMotion ? 0 : 0.5,
          },
        }}
        initial={{ opacity: 0, filter: 'blur(5px)', y: -25 }}
        transition={{
          type: 'spring',
          stiffness: 50,
          duration: 0.5,
        }}
      >
        <MABHero />
      </Motion>
      <Motion
        animate={{
          opacity: 1,
          filter: 'blur(0px)',
          y: 0,
          transition: {
            type: 'tween',
            duration: shouldReduceMotion ? 0 : 1,
            staggerChildren: shouldReduceMotion ? 0 : 0.5,
          },
        }}
        initial={{ opacity: 0, filter: 'blur(5px)', y: 25 }}
        transition={{
          type: 'spring',
          stiffness: 50,
          duration: 0.5,
        }}
      >
        <MABGrid profiles={profiles} />
      </Motion>
    </div>
  );
};

export default Content;
